<template>
  <div class="product-category-second-menu">
    <span
      v-for="(item, index) in items"
      :key="index"
      @click="onCategoryCode(item.code)"
    >
     <el-badge :value="item.count" :max="99" class="item" type="primary" :title="item.count">
         <i>{{item.name}}</i>
    </el-badge>
    </span>
  </div>
</template>
<script>
export default {
  name: "ProductCategorySecondMenu",
  props: ["items"],
  methods: {
    onCategoryCode(code) {
      this.$emit("selected", code);
    }
  }
};
</script>


<style lang="less" scoped>
.product-category-second-menu {
  span {
    color: #333;
    padding: 10px;
    white-space: nowrap;
    cursor: pointer;
    margin-right: 20px;
  }
  span:hover {
    color: #1b994f;
  }
  i{
    font-style: normal;
    margin-right: 5px;
  }
}
</style>
